var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { EJComponentDecorator } from '@syncfusion/ej2-vue-base';
let BulletRangeCollectionDirective = class BulletRangeCollectionDirective extends Vue {
    render() {
        return;
    }
};
BulletRangeCollectionDirective = __decorate([
    EJComponentDecorator({})
], BulletRangeCollectionDirective);
export { BulletRangeCollectionDirective };
export const BulletRangeCollectionPlugin = {
    name: 'e-bullet-range-collection',
    install(Vue) {
        Vue.component(BulletRangeCollectionPlugin.name, BulletRangeCollectionDirective);
    }
};
let BulletRangeDirective = class BulletRangeDirective extends Vue {
    render() {
        return;
    }
};
BulletRangeDirective = __decorate([
    EJComponentDecorator({})
], BulletRangeDirective);
export { BulletRangeDirective };
export const BulletRangePlugin = {
    name: 'e-bullet-range',
    install(Vue) {
        Vue.component(BulletRangePlugin.name, BulletRangeDirective);
    }
};
